import { Tooltip, TooltipProps } from '@mui/material';
import { ReactNode, FC, ReactElement } from 'react';
import { clsx } from 'clsx';

import './CustomTooltip.scss';

interface CustomTooltipProps extends TooltipProps {
  title: ReactNode;
  children: ReactElement;
  className?: string;
}

const CustomTooltip: FC<CustomTooltipProps> = ({ title, children, className = '', ...props }) => {
  return (
    <Tooltip
      {...props}
      title={title}
      arrow
      enterTouchDelay={0} // to enable working on mobile
      classes={{
        tooltip: clsx('custom-tooltip__tooltip', className),
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
